import { Injectable, ViewContainerRef } from '@angular/core';
import { VolunteerReportApi } from '../../api/volunteer-report.api';
import { InComplianceReportRequest } from '../../model/in-compliance-report-request.model';

@Injectable()
export class VolunteerReportService {
    constructor(private volunteerReportApi: VolunteerReportApi) { }

    getInComplianceReport = (request: InComplianceReportRequest) => this.volunteerReportApi.getInComplianceReport(request);

    downloadInComplianceReport = (request: InComplianceReportRequest) => this.volunteerReportApi.downloadInComplianceReport(request);
}